import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { REMOTE_KEYWORDS } from '#/utils/constants/search';

import { createRemotePrediction } from './createRemotePrediction';

type Args = {
  value: string;
  defaultKeyword: string;
  locale: I18nLocale;
};

export function getRemoteOptions({ value, defaultKeyword, locale }: Args) {
  const option = REMOTE_KEYWORDS[locale].find((kw) =>
    kw.toLowerCase().startsWith(value.toLowerCase()),
  );

  return option
    ? createRemotePrediction({ keyword: option, defaultKeyword })
    : undefined;
}
